import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';
import { SharedModule } from '../../shared/shared-module.module';
import { DescargaPolizaComponent } from './descarga-poliza.component';
import { SeleccionPolizaDialogComponent } from './seleccion-poliza-dialog.component';
import { DescargaPolizaRoutingModule } from './descarga-poliza-routing.module';

@NgModule({
  declarations: [
    DescargaPolizaComponent,
    SeleccionPolizaDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    DescargaPolizaRoutingModule
  ],
  exports: [DescargaPolizaComponent]
})
export class DescargaPolizaModule {}
